import { LoadingButton } from '@mui/lab';
import { Box, Button, ButtonGroup } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput from './PhoneInput';

export type RegisterFormProps = {
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  onSmsSubmit: () => Promise<void>;
  onWpSubmit: () => Promise<void>;
  submitting?: boolean;
};

export function RegisterForm({
  phoneNumber,
  setPhoneNumber,
  onSmsSubmit,
  onWpSubmit,
  submitting,
}: RegisterFormProps) {
  const { t } = useTranslation();
  const [method, setMethod] = useState<'sms' | 'wp'>('sms');

  const handleChange = (phone: string) => {
    setPhoneNumber(phone);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (method === 'sms') {
      await onSmsSubmit();
    } else {
      await onWpSubmit();
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Box mb={2}>
        <PhoneInput
          label={t('registerForm.phoneNumber')}
          name="phoneNumber"
          value={phoneNumber}
          onChange={handleChange}
          required
        />
      </Box>

      <ButtonGroup variant="outlined" fullWidth>
        <Button
          onClick={() => setMethod('sms')}
          variant={method === 'sms' ? 'contained' : 'outlined'}
        >
          {t('registerForm.selectSmsBtn')}
        </Button>
        <Button
          onClick={() => setMethod('wp')}
          variant={method === 'wp' ? 'contained' : 'outlined'}
        >
          {t('registerForm.selectWpBtn')}
        </Button>
      </ButtonGroup>

      {/* Submit */}
      <LoadingButton
        variant="contained"
        type="submit"
        color="secondary"
        sx={{ mt: 3, height: 48, width: '100%' }}
        disabled={submitting}
        loading={submitting}
      >
        {method === 'sms'
          ? t('registerForm.submitSmsBtn')
          : t('registerForm.submitWpBtn')}
      </LoadingButton>
    </Box>
  );
}
